import { Grid, GridItem } from 'uikit';

import type React from 'react';

import Style from './LabeledValue.module.css';

interface ILabeledValue {
    label: string;
    value: string;
}

export const LabeledValue: React.FC<ILabeledValue> = (props) => {
    const { label, value } = props;

    return (
        <Grid className={Style.labeledValue} rowGap="s" cols="3">
            <GridItem>
                <label>{label}: </label>
            </GridItem>
            <GridItem>
                <span>{value}</span>
            </GridItem>
        </Grid>
    );
};

LabeledValue.displayName = 'LabeledValue';
